import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { AboutComponent } from './about.component';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [
		AboutComponent,
	],
	imports: [
		CommonModule,
		IonicModule,
	],
	exports: [
		AboutComponent,
	]
})
export class AboutComponentModule {
	constructor() {

	}
}
